'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _typeof = require('./../../external/@babel/runtime/helpers/esm/typeof.js');
var React = require('react');
var index = require('./../../external/classnames/index.js');
var PropTypes = require('prop-types');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefault(React);
var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

var Section = function Section(_ref) {
  var backgroundColor = _ref.backgroundColor,
    children = _ref.children,
    className = _ref.className,
    id = _ref.id,
    isLinkable = _ref.isLinkable,
    noStyling = _ref.noStyling;
  React.useEffect(function () {
    if (isLinkable && id && location.hash == "#".concat(id)) {
      setTimeout(function () {
        location.href = location.hash;
      }, 1000);
    }
  }, []);
  var sectionClasses = index.default(className, {
    'lanl-section-with-padding': !noStyling,
    'lanl-section-with-no-styling': noStyling
  });
  return /*#__PURE__*/React__default.default.createElement("section", {
    id: id,
    "data-testid": "lanl-section",
    className: sectionClasses,
    style: !noStyling ? {
      backgroundColor: "".concat(backgroundColor)
    } : {}
  }, noStyling && children, !noStyling && /*#__PURE__*/React__default.default.createElement("div", {
    className: "lanl-section-container"
  }, children));
};
Section.defaultProps = {
  backgroundColor: '#F1EFF7',
  id: null,
  isLinkable: false,
  noStyling: false
};
Section.propTypes = {
  backgroundColor: PropTypes__default.default.string,
  children: PropTypes__default.default.node,
  className: PropTypes__default.default.string,
  id: function id(props, propName, componentName) {
    if (props['isLinkable'] && !props[propName]) {
      return new Error('id prop is required if isLinkable prop is true');
    }
    if (props[propName] && typeof props[propName] !== 'string') {
      return new Error("Invalid prop id of type '".concat(_typeof.default(props[propName]), "' supplied to '").concat(componentName, "', expected 'string' "));
    }
  },
  isLinkable: PropTypes__default.default.bool,
  noStyling: PropTypes__default.default.bool
};

exports.Section = Section;
exports.default = Section;
//# sourceMappingURL=Section.js.map
